<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from 'axios';
const moment = require('moment');
import _ from "lodash";

/**
 * Advanced-table component
 */
export default {
  page: {
    title: "Advanced Table",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      

      title: "Advanced",
      items: [
        {
          text: "Tables",
        },
        {
          text: "Advanced",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          label: "Nama Pelanggan",
          key: "customerData.name",
          sortable: true,
        },
        {
          label: "Kode Keluhan",
          key: "issue",
          sortable: true,
        },
        {
          label: "Tindakan",
          key: "actionTaken",
          sortable: true,
        },
        {
          label: "Tindakan Lanjutan",
          key: "nextAction",
          sortable: true,
        },
        {
          label: "Dibuat Oleh",
          key: "createdBy.fullName",
          sortable: true,
        },
        {
          label: "Pada",
          key: "createdAt",
          sortable: true,
          
        },
      ],
      dataShift:[],
      shiftHolder:'',
      dateHolder:null,
      adminHolder: '',
           
            regexHolder: "",
            customerData: [],
            listCustomer: [],
            holderCustomer:'',
            dataTambahKeluhan: {
                customerData:'',
                issue:'',
                actionTaken:'',
                nextAction:'',
            },
            selectedKodeKeluhan: null,
            selectedKodePenanganan: null,

            adminDoAction: [],
            kodeKeluhan: [
                { nama: 'k01' },
                { nama: 'k02' },
                { nama: 'k03' },
                { nama: 'k04' },
                { nama: 'k05' },
                { nama: 'k06' },
                { nama: 'k07' }
            ],
            adminActionOptions: {
                k01: [
                    { nama: 'Cek jaringan' },
                    { nama: 'Reset perangkat' }
                ],
                k02: [
                    { nama: 'Cek jaringan' },
                    { nama: 'Reset perangkat' }
                ],
                k03: [
                    { nama: 'Cek jaringan' },
                    { nama: 'Reset perangkat' }
                ],
                k04: [
                    { nama: 'Cek jaringan' },
                    { nama: 'Kirim Teknisi' }
                ],
                k05: [
                    { nama: 'Cek jaringan' },
                    { nama: 'Ganti Perangkat' }
                ],
                k06: [
                    { nama: 'Cek jaringan' },
                    { nama: 'Reset perangkat' }
                ],
                k07: [
                    { nama: 'Cek jaringan' },
                    { nama: 'Reset perangkat' },
                    { nama: 'Ganti perangkat' }
                ],

            },
            adminActionHolder: [],
            adminPenanggananHolder: [],
            adminAction: [
                {
                    name: 'SANCOKO_SAWUNGGALING',
                    issue: 'k01',
                    actionTaken: 'restart',
                    nextAction: 'tiket'
                }
            ],

    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return 0
    },
  },
  async mounted() {
    // Set the initial number of items
    this.adminHolder = this.$store.state.authfack.user.username
    this.totalRows = this.items.length
    const dateNow = new Date();
        const gmt7Time = new Date(dateNow.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' }));

        const hour = gmt7Time.getHours();

        let waktu;

        if (hour >= 8 && hour < 16) {
            waktu = 'Pagi';
        } else if (hour >= 16 && hour <= 23) {
            waktu = 'Malam';
        } else {
            waktu = 'di luar jam kerja';
        }
        this.dateHolder = waktu

        if(waktu === 'Malam'){
            this.shiftHolder=waktu
        }else {
          this.shiftHolder=waktu
        } 
        await this.getDataShift()

  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

   async getDataShift(){
   
    let url = "shift-service?shiftType="  + this.shiftHolder
    
    this.dataShift = await axios.get(process.env.VUE_APP_URL_FEATHERS + url).then(response => {
       // this.kategoriData.push(response.data.ticketDataPlusDetailMountly.dataTicketMountly)
       console.log('response.data',response.data.data);
       return response.data.data 

     })
   },
   formatDate(value) {
      if (!value) return '-';
      return moment(value).format('DD-MM-YYYY HH:mm');
    },
    async changeShiftData (value){
      console.log('sini',value);
      let loader = this.$loading.show({
      loader: 'spinner',
      color: '#ff5024'
    });
      
      let url = "shift-service?shiftType=" + value
    console.log('url',url);
    this.dataShift = await axios.get(process.env.VUE_APP_URL_FEATHERS + url).then(response => {
       // this.kategoriData.push(response.data.ticketDataPlusDetailMountly.dataTicketMountly)
       console.log('response.data',response.data.data);
       return response.data.data 

     })
     loader.hide()
    },
    modalKeluhan() {
           

           this.$refs['modal-keluhan'].show()
       },
       setKodeKeluhan(kode) {
           this.selectedKodeKeluhan = kode;
           this.dataTambahKeluhan.issue= kode
           this.adminActionHolder = this.adminActionOptions[kode] || [];
       },
       handleAdminAction(action) {
           console.log('Admin action dipilih:', action.nama);
           this.dataTambahKeluhan.actionTaken= action.nama
           this.selectedKodePenanganan = action.nama;
           this.adminPenanggananHolder = action.nama || [];
       },
       regexSearch: _.debounce(async function () {
           let loader = this.$loading.show({
               loader: 'spinner',
               color: '#ff5024'
           });
           let query = "";
           console.log('sini gaess', this.regexHolder);
           if (this.regexHolder.length >= 3) {
               query = query + "&regex=" + this.regexHolder;

               let url =
                   "customer-list?newTable=true&$skip=0&$limit=20"
                   +
                   query;
               console.log('query', query);
               console.log('url', url);
               this.customerData = await axios
                   .get(process.env.VUE_APP_URL_FEATHERS + url)
                   .then((response) => {
                       console.log('response', response.data);
                       return response.data.data;
                   });

               console.log('this.customerData', this.customerData);

           } else if (this.regexHolder.length < 3) {
               this.customerData = []
           }
           loader.hide()
       }, 200),
       onSearch(search, loading) {
       if (search.length) {
           loading(true);
           this.getCustomer(loading, search, this);
       }
       },
       async getCustomer(loading, search, vm) {
       vm.listCustomer = await axios.get(process.env.VUE_APP_URL_FEATHERS + 'customer-data?searchCustomer=' + search)
           .then(response => {
           
           loading(false);
           
           return response.data
           })
       },
       async setSelectedCustomer(value) {
           this.holderCustomer = value.id

           this.dataTambahKeluhan.customerData= value.id
           },
           async testing(){
               await axios.post(process.env.VUE_APP_URL_FEATHERS + 'shift-service', this.dataTambahKeluhan).then(async response => {
                   console.log('response',response);
                  await this.getDataShift()
               })
               console.log('this.dataTambahKeluhan',this.dataTambahKeluhan);
               
           }
  
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Shift Follow up
              <div class="d-flex justify-content-end align-items-center">
            <span class="fw-semibold me-2">Tambah Keluhan</span>
            <b-button size="sm" @click="modalKeluhan">
              <span class="fas fa-plus-circle"></span>
            </b-button>
          </div>
            </h4>
            
               

            <div class="row mt-4">
              <div class="col-sm-12 col-md-5">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                    
                  </label>
                 
                  
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-7">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-lg-end"
                >
                <div class="float-end" style="margin-left: 20px;">
                      <b-button class="me-2" size="sm" variant="info" @click="changeShiftData('Pagi')"> Pagi</b-button>
                      <b-button size="sm" @click="changeShiftData('Malam')"> Malam</b-button>
                    </div>
                  <label class="d-inline-flex align-items-center">
                   
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                 
                </div>
                
              </div>
              
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="dataShift"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template #cell(createdAt)="data">
                  {{ formatDate(data.item.createdAt) }}
                </template>
            </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="modal-keluhan" centered title="Tambahkan Keluhan Pelanggan" title-class="font-18"
                    size="md" @ok="testing">
                    <div class="row">
                        <div class="col">
                            <div>
                                Shift
                            </div>
                            <div class="mt-3">

                                Di Buat Oleh
                            </div>
                            <div class="mt-3">
                                Nama Pelanggan
                            </div>
                            <div class="mt-3">
                                Code Keluhan
                            </div>
                            <div class="mt-3">
                                Tindakan
                            </div>
                            <div class="mt-3">
                                Tindakan Lanjutan
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <b-button size="sm" :variant="dateHolder === 'Pagi' ? 'primary' : ''" disabled
                                    style="min-width: 225px;">
                                    {{ dateHolder }}
                                </b-button>
                            </div>
                            <div>
                                <b-button size="sm" class="mt-2" disabled style="min-width: 225px;" variant="success">{{
                                    this.adminHolder }}</b-button>
                            </div>
                            <div>
                                <div class="col-sm-12 mt-2">
                                <v-select label="customerName" :filterable="false" :options="listCustomer" @search="onSearch"
                                    @input="setSelectedCustomer">
                                    <template slot="no-options">
                                    Ketik nama pelanggan..
                                    </template>
                                    <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.customerName }}
                                    </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.customerName }}
                                    </div>
                                    </template>
                                </v-select>
                                </div>

                            </div>
                            <div class="mt-2">
                                <div class="mt-2">
                                    <b-dropdown size="sm" :text="selectedKodeKeluhan || 'Pilih Kode Keluhan'"
                                        variant="success" style="min-width: 120px;">
                                        <b-dropdown-item v-for="(item, index) in kodeKeluhan" :key="index"
                                            @click="setKodeKeluhan(item.nama)">
                                            {{ item.nama }}
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>


                            </div>

                            <div class="mt-2">
                                <b-dropdown size="sm" :text="selectedKodePenanganan || 'Pilih Admin Action'"
                                    variant="primary" v-if="adminAction.length" style="min-width: 120px;">
                                    <b-dropdown-item v-for="(item, index) in adminActionHolder" :key="index"
                                        @click="handleAdminAction(item)">
                                        {{ item.nama }}
                                    </b-dropdown-item>
                                </b-dropdown>
                                <p v-else class="text-muted">Silakan pilih kode keluhan dulu</p>
                            </div>
                            <div class="mt-2">
                                <b-textarea size="sm" v-model="dataTambahKeluhan.nextAction"></b-textarea>
                            </div>
                        </div>
                    </div>
                </b-modal>
  </Layout>
</template>
